import DamagePhotos from '@/features/v2/hh/components/documents/DamagePhotos';
import DamageProtocol from '@/features/v2/hh/components/documents/DamageProtocol';
import DamageReport from '@/features/v2/hh/components/documents/DamageReport';
import DryingReport from '@/features/v2/hh/components/documents/DryingReport';
import InsurerPolicy from '@/features/v2/hh/components/documents/InsurerPolicy';
import InsurersDecision from '@/features/v2/hh/components/documents/InsurersDecision';
import InsurersEstimate from '@/features/v2/hh/components/documents/InsurersEstimate';
import Invoices from '@/features/v2/hh/components/documents/Invoices';
import { HHSchema } from '@/features/v2/hh/stepsSchema';
import { useStepper } from '@/features/v2/lib/stepper';

import { useFormContext } from 'react-hook-form';
export const Uploader = () => {
  const { step, innerStep } = useStepper();

  const { watch } = useFormContext();

  const additionalSteps = HHSchema[step]?.lastStep?.(watch());

  const { additionalStep, secondAdditionalStep, dryingReport } =
    additionalSteps || {};

  const plusAdditional = additionalStep ? 1 : 0;
  const plusSecondAdditional = secondAdditionalStep ? 1 : 0;

  return (
    <>
      {innerStep === 0 && <InsurersDecision required />}
      {innerStep === 1 && additionalStep && <InsurerPolicy />}
      {innerStep === 1 + plusAdditional && <DamagePhotos />}
      {innerStep === 2 + plusAdditional && secondAdditionalStep && <Invoices />}
      {innerStep === 2 + plusAdditional + plusSecondAdditional && (
        <InsurersEstimate />
      )}
      {innerStep === 3 + plusAdditional + plusSecondAdditional && (
        <DamageReport />
      )}
      {innerStep === 4 + plusAdditional + plusSecondAdditional && (
        <DamageProtocol />
      )}
      {innerStep === 5 + plusAdditional + plusSecondAdditional &&
        dryingReport && <DryingReport />}
    </>
  );
};
